<template>
  <div>
    <div class="icon-box program" @click.prevent="openInfoPopup">
      <ProgramButton/>
      <span class="icon-txt">프로그램</span>
    </div>
    <portal to="info-popup" v-if="isOpenInfoPopup">
            <div class="info-popup-background"></div>
      <div class="info-popup-wrapper">
        <div class="popup-middle">
          <div :class="isEmptyContent ? 'popup empty' : 'popup'">
            <!--<div class="close-btn" @click.prevent="closeInfoPopup"></div>-->
            <div class="title" v-html="contentInfo.programtitle"></div>
            <div class="sub-info">
              {{contentInfo.channelname}}<i class="icon-dotted"></i>
              {{contentInfo.programreleaseweekday}}<i class="icon-dotted"></i>
              {{contentInfo.programstarttime}}~{{contentInfo.programendtime}}
            </div>
            <div class="synopsis" v-if="isEmptyContent">프로그램 정보가 없습니다.</div>
            <div class="synopsis" v-html="contentInfo.programsynopsis" v-else></div>
            <div class="info-popup-close-btn" @click.prevent="closeInfoPopup">확인</div>
          </div>
        </div>
      </div>
    </portal>
  </div>

</template>
<script>
import ProgramButton from '@/assets/svg/common/ic-detail-info.svg'
import { disableBodyScroll, enableBodyScroll } from '@/common/util/ui.utils'
import { get } from 'lodash'

export default {
  name: 'IconBoxProgram',
  components: { ProgramButton },
  props: {
    contentInfo: {
      type: Object
    }
  },
  data () {
    return {
      isOpenInfoPopup: false
    }
  },
  methods: {
    openInfoPopup () {
      disableBodyScroll()
      document.getElementsByClassName('play-container')[0].classList.add('chrome-fixed')
      this.isOpenInfoPopup = true
      this.$nextTick(() => {
        document.querySelector('.synopsis').addEventListener('scroll', this.scrollEvent)
        document.body.addEventListener('touchmove', this.preventEvent, { passive: false })
      })
    },
    scrollEvent (e) {
      if (e.target.scrollTop <= 0) {
        e.target.scrollTop = 1
      } else if (e.target.scrollTop === e.target.scrollHeight - e.target.clientHeight) {
        e.target.scrollTop = e.target.scrollTop - 1
      }
    },
    preventEvent (e) {
      if (e.srcElement.classList.value === 'synopsis') return
    //  e.preventDefault()
    },
    closeInfoPopup () {
      enableBodyScroll()
      document.getElementsByClassName('play-container')[0].classList.remove('chrome-fixed')
      document.querySelector('.synopsis').removeEventListener('scroll', this.scrollEvent)
      document.body.removeEventListener('touchmove', this.preventEvent)
      this.isOpenInfoPopup = false
    }
  },
  computed: {
    isEmptyContent () {
      const synopsis = get(this.contentInfo, 'programsynopsis', null)
      return synopsis === null || synopsis.length === 0
    }
  }
}
</script>
<style scoped>
  .info-popup-wrapper {
    display: table;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 5000;
  }
  .info-popup-background {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 4000;
  }
  .popup-middle {
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -200px;
    margin-left: -130px;
    display: flex;
    align-items: center;
    height: 400px;
  }
  .popup {
    position:relative;
    margin-left: auto;
    margin-right: auto;
    width: 260px;
    padding: 40px 0;
    background-color: #252525;
    overflow-scrolling: touch;
    -webkit-overflow-scrolling: touch;
    overflow: hidden;
  }
  .popup::-webkit-scrollbar{
    display: none
  }
  .popup.empty {
    height: 265px;
  }
  .popup:after{
    position: absolute;
    bottom: 94px;
    display: block;
    content: '';
    width: 315px;
    height: 32px;
    background-image: linear-gradient(to bottom, rgba(37, 37, 37, 0), rgba(37, 37, 37, 0.8));
  }
  .popup .close-btn {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 10px;
    right: 10px;
  }
  .popup .title,
  .popup .sub-info{
    color: #fff;
  }
  .popup .title {
    position: relative;
    display: block;
    display: -webkit-box;
    padding: 0 20px;
    margin-bottom: 2px;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    overflow:hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .popup .sub-info {
    position: relative;
    text-align: center;
    font-size: 14px;
    line-height: 18px;
  }
  .popup.empty .synopsis {
    height: 50px;
  }
  .popup .synopsis{
    position: relative;
    min-height: 56px;
    max-height: 166px;
    margin: 20px 20px 56px;
    padding-bottom: 32px;
    overflow-y: scroll;
    overflow-scrolling: touch;
    -webkit-overflow-scrolling: touch;
    font-size: 14px;
    line-height: 18px;
    color: #a5a5a5;
  }
  .popup .synopsis::-webkit-scrollbar{
    display: none
  }
  .info-popup-close-btn  {
    position: absolute;
    bottom: 40px;
    left: 20px;
    width: 220px;
    height: 36px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    background-color: #1351f9;
    line-height: 36px;
    margin: 0 auto;
    border-radius: 17px 17px 17px 17px
  }

  @media screen and (min-width: 321px){
    .popup-middle {
      margin-top: -247px;
      margin-left: -157px;
      height: 494px;
    }
    .popup {
      width: 315px;
    }
    .popup .synopsis {
      max-height: 260px;
    }
    .info-popup-close-btn  {
      width: 275px;
    }
  }
</style>
